import 'whatwg-fetch';

import React, { Component } from 'react';

import HomepageArticles from './HomepageArticles';

export default class HomepageArchitizerJournal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      featuredArticles: {
        rss: {
          channel: {
            title: 'Journal',
            link: [
              {
                _href: 'https://architizer.wpengine.com/feed/',
                _rel: 'self',
                _type: 'application/rss+xml',
                __prefix: 'atom',
              },
              'https://architizer.wpengine.com',
            ],
            description: 'How architects find building-products.',
            lastBuildDate: 'Tue, 07 Nov 2017 14:38:51 +0000',
            language: 'en-US',
            updatePeriod: {
              __prefix: 'sy',
              __text: 'hourly',
            },
            updateFrequency: {
              __prefix: 'sy',
              __text: '1',
            },
            item: [
              {
                title: 'The Ultimate Search Engine for Architects',
                link: 'https://architizer.com/blog/inside-architizer/updates/manufacturer-search-for-architects/',
                image_url: 'https://architizer-prod.imgix.net/media/manufacturer-search-for-architects.jpg',
              },
              {
                title: 'Introducing the Architizer Journal for Architects',
                link: 'https://architizer.com/blog/inside-architizer/pro-tips/architizer-journal-for-architects/',
                image_url: 'https://architizer-prod.imgix.net/media/architizer-journal-for-architects.jpg',
              },
              {
                title: 'How SHoP Architects Sourced a Copper Skin for NYC\'s Newest Skyscraper',
                link: 'https://architizer.com/blog/inspiration/stories/architizer-source-shop-architects/',
                image_url: 'https://architizer-prod.imgix.net/media/architizer-source-shop-architects.jpeg',
              },
              {
                title: 'Fired Up: 5 Textured Buildings With Terracotta Screens',
                link: 'https://architizer.com/blog/inspiration/collections/terracotta-louvers/',
                image_url: 'https://architizer-prod.imgix.net/media/terracotta-louvers.jpg',
              },
            ],
          },
        },
      },
    };
  }

  render() {
    return (
      <div>
        <HomepageArticles featuredArticles={this.state.featuredArticles} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./js/src/components/homepage/HomepageArchitizerJournal.jsx